var _defs, _rect, _g, _defs2, _path, _g2, _defs3, _path2, _defs4, _g3, _rect2, _g4, _defs5, _path3, _g5, _defs6, _path4, _defs7, _g6, _defs8, _defs9, _rect3, _g7, _defs10, _path5, _g8, _defs11, _path6, _defs12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVlLogoTransparentBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: 0,
    y: 0,
    width: 2400,
    height: 2400,
    viewBox: "93.755 48.755 152.49 152.49",
    preserveAspectRatio: "xMidYMid meet",
    colorInterpolationFilters: "sRGB",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: 92,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa71cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#9b59b6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 93,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f83600"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 94,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0064d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1cb0f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 95,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f00978"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#3f51b1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 96,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7873f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ec77ab"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 97,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f9d423"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#e14fad"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 98,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#009efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2af598"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 99,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffcc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00b140"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 100,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#d51007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ff8177"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 102,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#a2b6df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c3483"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 103,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#7ac5d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#eea2a2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 104,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00ecbc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#007adf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: 105,
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#b88746"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fdf5a6"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "iconmbgsvg",
    transform: "translate(101.25,56.25000019303019)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#333333",
    "hollow-target": "textFill",
    mask: "url(#8cf66044-ee15-4e1a-bc69-fcc29ddfcfc0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1684ac",
    className: "iconsvg-imagesvg icon_container",
    mask: "url(#48ead649-86a9-4035-868a-21dd364d094c)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 137.5,
    height: 137.5,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60.016204375181296",
    x: 0,
    y: 0,
    width: 137.5,
    height: 137.5,
    className: "image-svg-svg bn",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "hollow-target": "iconBnFill",
    mask: "url(#18dde0a3-26e4-4c4a-b5d0-58e7db2af19c)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.67096 -0.01778 61.01638 61.0331",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 60.016204375181296,
    x: 0,
    y: 0,
    filtersec: "colorsf1238025106",
    filter: "url(#Hsu4IeLvY5mfIfbFxHAr7)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.808 34.993a10.32 10.32 0 0 0-1.843 6.801 10.296 10.296 0 0 1-7.626 10.827 10.295 10.295 0 0 0-5.78 4.027 10.304 10.304 0 0 1-12.802 3.39 10.309 10.309 0 0 0-7.017-.631 10.305 10.305 0 0 1-11.989-5.63 10.271 10.271 0 0 0-4.969-4.996 10.299 10.299 0 0 1-5.56-12.018 10.311 10.311 0 0 0-.596-7.02 10.295 10.295 0 0 1 3.46-12.781A10.29 10.29 0 0 0 9.145 11.2a10.3 10.3 0 0 1 10.868-7.566 10.306 10.306 0 0 0 6.81-1.804 10.302 10.302 0 0 1 13.192 1.19 10.286 10.286 0 0 0 6.377 2.993c4.977.45 8.916 4.41 9.34 9.391a10.295 10.295 0 0 0 2.956 6.394 10.297 10.297 0 0 1 1.12 13.195",
    fill: "#000",
    fillRule: "evenodd"
  }))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Hsu4IeLvY5mfIfbFxHAr7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0859375  0 0 0 0 0.515625  0 0 0 0 0.671875  0 0 0 1 0"
  })))))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#colors7069335965)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.004062533378601074 0.00234222412109375 50.02000045776367 46.650001525878906",
    width: 34.8,
    height: 34.809396,
    x: 12.600000000000001,
    y: 12.603404187590648,
    className: "image-svg-letter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.9140625 46.65234375)",
    d: "M14.94-46.65L31.08 0L15.96 0L-0.91-46.65L14.94-46.65ZM25.98-21.94L33.50-46.65L49.11-46.65L32.98-1.41L25.98-21.94Z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "18dde0a3-26e4-4c4a-b5d0-58e7db2af19c"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.67096 -0.01778 61.01638 61.0331",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 60.016204375181296,
    x: 0,
    y: 0,
    filtersec: "colorsf1238025106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.808 34.993a10.32 10.32 0 0 0-1.843 6.801 10.296 10.296 0 0 1-7.626 10.827 10.295 10.295 0 0 0-5.78 4.027 10.304 10.304 0 0 1-12.802 3.39 10.309 10.309 0 0 0-7.017-.631 10.305 10.305 0 0 1-11.989-5.63 10.271 10.271 0 0 0-4.969-4.996 10.299 10.299 0 0 1-5.56-12.018 10.311 10.311 0 0 0-.596-7.02 10.295 10.295 0 0 1 3.46-12.781A10.29 10.29 0 0 0 9.145 11.2a10.3 10.3 0 0 1 10.868-7.566 10.306 10.306 0 0 0 6.81-1.804 10.302 10.302 0 0 1 13.192 1.19 10.286 10.286 0 0 0 6.377 2.993c4.977.45 8.916 4.41 9.34 9.391a10.295 10.295 0 0 0 2.956 6.394 10.297 10.297 0 0 1 1.12 13.195",
    fillRule: "evenodd"
  }))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null)))), /*#__PURE__*/React.createElement("g", {
    fill: "black"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.004062533378601074 0.00234222412109375 50.02000045776367 46.650001525878906",
    width: 34.8,
    height: 34.809396,
    x: 12.600000000000001,
    y: 12.603404187590648,
    className: "image-svg-letter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.9140625 46.65234375)",
    d: "M14.94-46.65L31.08 0L15.96 0L-0.91-46.65L14.94-46.65ZM25.98-21.94L33.50-46.65L49.11-46.65L32.98-1.41L25.98-21.94Z"
  })))))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors7069335965"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0859375  0 0 0 0 0.515625  0 0 0 0 0.671875  0 0 0 1 0",
    className: "icon-feColorMatrix "
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf1238025106"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb140966963"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })))), /*#__PURE__*/React.createElement("rect", {
    "v-gra": "id",
    width: 149.5,
    height: 149.5,
    transform: "translate(-6, -6)",
    style: {
      pointerEvents: "none"
    },
    fill: "url(#R6rYpCJJ83MnYx0y9qni-)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.75,71.75)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    transform: "translate(0, 0)"
  })))))))), /*#__PURE__*/React.createElement("mask", {
    id: "8cf66044-ee15-4e1a-bc69-fcc29ddfcfc0"
  }, /*#__PURE__*/React.createElement("g", {
    className: "iconsvg-imagesvg icon_container",
    fill: "white"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 137.5,
    height: 137.5,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60.016204375181296",
    x: 0,
    y: 0,
    width: 137.5,
    height: 137.5,
    className: "image-svg-svg bn",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "hollow-target": "iconBnFill",
    mask: "url(#18dde0a3-26e4-4c4a-b5d0-58e7db2af19c)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.67096 -0.01778 61.01638 61.0331",
    width: 60,
    height: 60.016204375181296,
    x: 0,
    y: 0,
    filter: "url(#colorsf1238025106)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.808 34.993a10.32 10.32 0 0 0-1.843 6.801 10.296 10.296 0 0 1-7.626 10.827 10.295 10.295 0 0 0-5.78 4.027 10.304 10.304 0 0 1-12.802 3.39 10.309 10.309 0 0 0-7.017-.631 10.305 10.305 0 0 1-11.989-5.63 10.271 10.271 0 0 0-4.969-4.996 10.299 10.299 0 0 1-5.56-12.018 10.311 10.311 0 0 0-.596-7.02 10.295 10.295 0 0 1 3.46-12.781A10.29 10.29 0 0 0 9.145 11.2a10.3 10.3 0 0 1 10.868-7.566 10.306 10.306 0 0 0 6.81-1.804 10.302 10.302 0 0 1 13.192 1.19 10.286 10.286 0 0 0 6.377 2.993c4.977.45 8.916 4.41 9.34 9.391a10.295 10.295 0 0 0 2.956 6.394 10.297 10.297 0 0 1 1.12 13.195",
    fillRule: "evenodd"
  }))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null)))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.004062533378601074 0.00234222412109375 50.02000045776367 46.650001525878906",
    width: 34.8,
    height: 34.809396,
    x: 12.600000000000001,
    y: 12.603404187590648,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.9140625 46.65234375)",
    d: "M14.94-46.65L31.08 0L15.96 0L-0.91-46.65L14.94-46.65ZM25.98-21.94L33.50-46.65L49.11-46.65L32.98-1.41L25.98-21.94Z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "18dde0a3-26e4-4c4a-b5d0-58e7db2af19c"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.67096 -0.01778 61.01638 61.0331",
    width: 60,
    height: 60.016204375181296,
    x: 0,
    y: 0,
    filtersec: "colorsf1238025106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.808 34.993a10.32 10.32 0 0 0-1.843 6.801 10.296 10.296 0 0 1-7.626 10.827 10.295 10.295 0 0 0-5.78 4.027 10.304 10.304 0 0 1-12.802 3.39 10.309 10.309 0 0 0-7.017-.631 10.305 10.305 0 0 1-11.989-5.63 10.271 10.271 0 0 0-4.969-4.996 10.299 10.299 0 0 1-5.56-12.018 10.311 10.311 0 0 0-.596-7.02 10.295 10.295 0 0 1 3.46-12.781A10.29 10.29 0 0 0 9.145 11.2a10.3 10.3 0 0 1 10.868-7.566 10.306 10.306 0 0 0 6.81-1.804 10.302 10.302 0 0 1 13.192 1.19 10.286 10.286 0 0 0 6.377 2.993c4.977.45 8.916 4.41 9.34 9.391a10.295 10.295 0 0 0 2.956 6.394 10.297 10.297 0 0 1 1.12 13.195",
    fillRule: "evenodd"
  }))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null)))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.004062533378601074 0.00234222412109375 50.02000045776367 46.650001525878906",
    width: 34.8,
    height: 34.809396,
    x: 12.600000000000001,
    y: 12.603404187590648,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.9140625 46.65234375)",
    d: "M14.94-46.65L31.08 0L15.96 0L-0.91-46.65L14.94-46.65ZM25.98-21.94L33.50-46.65L49.11-46.65L32.98-1.41L25.98-21.94Z"
  })))))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(68.75,71.75)",
    fill: "black"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "",
    className: "tp-name"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "",
    transform: "translate(0, 0)"
  }))))))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "od"
  })), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", {
    "v-gra": "id"
  }, /*#__PURE__*/React.createElement("filter", {
    id: "7706c8a1-ee8a-4f76-98bb-21e76c42557d",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0,
    id: "R6rYpCJJ83MnYx0y9qni-"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fa709a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#ffe13f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "42443b3f1de60f6b6fd3b6a9844b4764",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0"
  })))), /*#__PURE__*/React.createElement("mask", {
    "v-gra": "im",
    id: "48ead649-86a9-4035-868a-21dd364d094c"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#1684ac",
    className: "iconsvg-imagesvg icon_container",
    filter: "url(#7706c8a1-ee8a-4f76-98bb-21e76c42557d)"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "#333333",
    fillOpacity: 0,
    strokeWidth: 2,
    x: 0,
    y: 0,
    width: 137.5,
    height: 137.5,
    className: "image-rect"
  })), /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60.016204375181296",
    x: 0,
    y: 0,
    width: 137.5,
    height: 137.5,
    className: "image-svg-svg bn",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "hollow-target": "iconBnFill",
    mask: "url(#18dde0a3-26e4-4c4a-b5d0-58e7db2af19c)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.67096 -0.01778 61.01638 61.0331",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 60.016204375181296,
    x: 0,
    y: 0,
    filtersec: "colorsf1238025106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.808 34.993a10.32 10.32 0 0 0-1.843 6.801 10.296 10.296 0 0 1-7.626 10.827 10.295 10.295 0 0 0-5.78 4.027 10.304 10.304 0 0 1-12.802 3.39 10.309 10.309 0 0 0-7.017-.631 10.305 10.305 0 0 1-11.989-5.63 10.271 10.271 0 0 0-4.969-4.996 10.299 10.299 0 0 1-5.56-12.018 10.311 10.311 0 0 0-.596-7.02 10.295 10.295 0 0 1 3.46-12.781A10.29 10.29 0 0 0 9.145 11.2a10.3 10.3 0 0 1 10.868-7.566 10.306 10.306 0 0 0 6.81-1.804 10.302 10.302 0 0 1 13.192 1.19 10.286 10.286 0 0 0 6.377 2.993c4.977.45 8.916 4.41 9.34 9.391a10.295 10.295 0 0 0 2.956 6.394 10.297 10.297 0 0 1 1.12 13.195",
    fill: "#000",
    fillRule: "evenodd"
  }))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Hsu4IeLvY5mfIfbFxHAr7"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0859375  0 0 0 0 0.515625  0 0 0 0 0.671875  0 0 0 1 0"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.004062533378601074 0.00234222412109375 50.02000045776367 46.650001525878906",
    width: 34.8,
    height: 34.809396,
    x: 12.600000000000001,
    y: 12.603404187590648,
    className: "image-svg-letter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.9140625 46.65234375)",
    d: "M14.94-46.65L31.08 0L15.96 0L-0.91-46.65L14.94-46.65ZM25.98-21.94L33.50-46.65L49.11-46.65L32.98-1.41L25.98-21.94Z"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "18dde0a3-26e4-4c4a-b5d0-58e7db2af19c"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "white"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0.67096 -0.01778 61.01638 61.0331",
    style: {
      overflow: "visible"
    },
    width: 60,
    height: 60.016204375181296,
    x: 0,
    y: 0,
    filtersec: "colorsf1238025106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1, 1) skewX(0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.808 34.993a10.32 10.32 0 0 0-1.843 6.801 10.296 10.296 0 0 1-7.626 10.827 10.295 10.295 0 0 0-5.78 4.027 10.304 10.304 0 0 1-12.802 3.39 10.309 10.309 0 0 0-7.017-.631 10.305 10.305 0 0 1-11.989-5.63 10.271 10.271 0 0 0-4.969-4.996 10.299 10.299 0 0 1-5.56-12.018 10.311 10.311 0 0 0-.596-7.02 10.295 10.295 0 0 1 3.46-12.781A10.29 10.29 0 0 0 9.145 11.2a10.3 10.3 0 0 1 10.868-7.566 10.306 10.306 0 0 0 6.81-1.804 10.302 10.302 0 0 1 13.192 1.19 10.286 10.286 0 0 0 6.377 2.993c4.977.45 8.916 4.41 9.34 9.391a10.295 10.295 0 0 0 2.956 6.394 10.297 10.297 0 0 1 1.12 13.195",
    fillRule: "evenodd"
  }))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null)))), /*#__PURE__*/React.createElement("g", {
    fill: "black"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0.004062533378601074 0.00234222412109375 50.02000045776367 46.650001525878906",
    width: 34.8,
    height: 34.809396,
    x: 12.600000000000001,
    y: 12.603404187590648,
    className: "image-svg-letter",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0.9140625 46.65234375)",
    d: "M14.94-46.65L31.08 0L15.96 0L-0.91-46.65L14.94-46.65ZM25.98-21.94L33.50-46.65L49.11-46.65L32.98-1.41L25.98-21.94Z"
  })))))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "colors7069335965"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0859375  0 0 0 0 0.515625  0 0 0 0 0.671875  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsf1238025106"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 0 0.99609375  0 0 0 1 0",
    className: "icon-fecolormatrix"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "colorsb140966963"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0  0 0 0 0 0  0 0 0 1 0",
    className: "icon-fecolormatrix"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVlLogoTransparentBg);
export default __webpack_public_path__ + "static/media/vl-logo-transparentBg.aae919660a9a052cd967b96f0066dfe6.svg";
export { ForwardRef as ReactComponent };